import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { moduleKeys } from '@entities/Module';
import { fetchDailyTask, startDailyTask } from '../api/dailyTaskApi';

export const dailyTaskKeys = {
  today: ['daily-task'] as const,
};

export function useDailyTaskQuery() {
  return useQuery({ queryKey: dailyTaskKeys.today, queryFn: fetchDailyTask, staleTime: 60_000 });
}

/** Взять задание: слова ложатся в модуль «Задания дня» — список модулей перечитываем. */
export function useStartDailyTaskMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: startDailyTask,
    onSuccess: (task) => {
      qc.setQueryData(dailyTaskKeys.today, task);
      void qc.invalidateQueries({ queryKey: moduleKeys.listsRoot });
    },
  });
}
